import React from "react"
import { css, useTheme } from "@emotion/react"
import { StyledCheckbox } from "./StyledCheckbox"
import { BodySubtextNormal, BodyTextRegular } from "../../typography/text"

type Props = {
  label?: string
  innerRef?: any
  innerText?: string
  labelLink?: React.ReactNode
  wrapperWidth?: string
  description?: string
  LeftComponent?: React.ReactNode
  wrapperRef?: React.RefObject<HTMLDivElement>
  textSize?: "small" | "regular"
} & React.ClassAttributes<HTMLInputElement> &
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >

export const CheckboxField = ({
  label,
  innerRef,
  labelLink,
  disabled,
  innerText,
  wrapperWidth,
  wrapperRef,
  description,
  LeftComponent,
  textSize = "regular",
  ...rest
}: Props) => {
  const theme = useTheme()

  const checkboxStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    min-width: fit-content;
    margin-bottom: 0px;
    cursor: pointer;
    &:hover {
      > div > .customElement {
        background-color: ${theme.colors.whiteHover};
      }
      > div > input:checked ~ .customElement {
        background-color: ${theme.colors.ctaMain};
      }
      > div > input:disabled ~ .customElement {
        background-color: ${theme.colors.ctaInactive};
      }
    }
    width: ${wrapperWidth || "fit-content"};
  `

  const labelStyle = css`
    cursor: ${disabled ? "default" : "pointer"};
  `

  const TextComponent =
    textSize === "small" ? BodySubtextNormal : BodyTextRegular

  return (
    <label css={checkboxStyle}>
      <div ref={wrapperRef}>
        <StyledCheckbox
          innerText={innerText}
          disabled={disabled}
          innerRef={innerRef}
          {...rest}
        />
      </div>
      {LeftComponent && LeftComponent}
      <div className="flex flex-col gap-1 whitespace-pre-wrap">
        {label && (
          <TextComponent
            color={disabled ? theme.colors.secondary2 : theme.colors.primary}
            css={labelStyle}
          >
            {label} {labelLink}
          </TextComponent>
        )}
        {description && (
          <BodySubtextNormal color={theme.colors.secondary2}>
            {description}
          </BodySubtextNormal>
        )}
      </div>
    </label>
  )
}
